import React from "react";
import { StockTransferModal } from "../StockTransferModal";

const TRANSFER_OPTION = {
  id: "material-loan-customer",
  value: "Material_On_Loan_To_Customer",
  labelKey: "inventory.transferMaterialOnLoanToCustomer",
  party: "customer",
};

export function MaterialOnLoanToCustomerModal({ open, onOpenChange, onSuccess }) {
  return (
    <StockTransferModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      transferOption={TRANSFER_OPTION}
    />
  );
}
